const Routes_Main = {
    userLogin:"/",
    forgotPassword:"forgot-password",
    emailVerification:"user/verification/:token/:username",
    userDashboard:"user-dashboard"

}
export {Routes_Main};